import { render, staticRenderFns } from "./PowerBiReport.vue?vue&type=template&id=4d6121f2&scoped=true"
import script from "./PowerBiReport.vue?vue&type=script&lang=js"
export * from "./PowerBiReport.vue?vue&type=script&lang=js"
import style0 from "./PowerBiReport.vue?vue&type=style&index=0&id=4d6121f2&prod&lang=scss&scoped=true"
import style1 from "./PowerBiReport.vue?vue&type=style&index=1&id=4d6121f2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d6121f2",
  null
  
)

export default component.exports